import XML2JS from 'xml2js';
import Analytics from './Analytics'

function weatherAlert(data) {
  const isEmptyObject = function(obj) {
    let name;
    for (name in obj) {
      return false;
    }
    return true;
  };

  const isArray = function(obj) {
    return Object.prototype.toString.call(obj) === '[object Array]';
  };


  let tmpArr = [];
  let tornadoArr = [];
  let otherArr = [];

  if (!data.Alert) //desn't exist
    data.Alert = []
  if (!isArray(data.Alert)) //must be single object
    data.Alert = [data.Alert]
  if (!isEmptyObject(data)) {

    let warnings = data.Alert;


    let tornadoWarnings = warnings.filter(warning => warning.type === 'Tornado Warning');
    let otherWarnings = warnings.filter(warning => warning.type !== 'Tornado Warning');
    tornadoWarnings.forEach((tornadoWarning) => {
      let countylist = tornadoWarning['AffectedAreas']['Area'];
      if (isArray(countylist)) {
        countylist.forEach((warning) => {

          tornadoArr.push({
            county: warning.id,
            type: 'Tornado Warning',
            alertTextShort: tornadoWarning.AlertTextShort.section,
            alertTextLong: tornadoWarning.AlertTextLong.section,
            open: false
          });
        });
      } else {
        tornadoArr.push({
          county: countylist.id,
          type: 'Tornado Warning',
          alertTextShort: tornadoWarning.AlertTextShort.section,
          alertTextLong: tornadoWarning.AlertTextLong.section,
          open: false
        });
      }
    });
    otherWarnings.forEach((otherWarning) => {
      let warningType = otherWarning['type'];
      let countylist = otherWarning['AffectedAreas']['Area'];
      if (isArray(countylist)) {
        countylist.forEach((warning) => {
          otherArr.push({
            county: warning.id,
            type: warningType,
            alertTextShort: otherWarning.AlertTextShort.section,
            alertTextLong: otherWarning.AlertTextLong.section,
            open: false
          });
        });
      } else {
        otherArr.push({
          county: countylist.id,
          type: warningType,
          alertTextShort: otherWarning.AlertTextShort.section,
          alertTextLong: otherWarning.AlertTextLong.section,
          open: false
        });
      }
    });


    tornadoArr.sort(function(a, b) {
      return a.county.localeCompare(b.county);
    });
    otherArr.sort(function(a, b) {
      return a.county.localeCompare(b.county);
    });
    tmpArr = tornadoArr.concat(otherArr);


    return tmpArr
  }
}

function forecast(forecastdata) {
  const dayArr = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const monthArr = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August',
    'September', 'October', 'November', 'December'
  ];
  //convertToJson from xml
  function formatIcon(icon) {
    if (icon.indexOf('/') > -1) {
      return icon.split('/')[1];
    } else {
      return icon;
    }
  }

  let forecasts = [];
  let jsondata;


  if (typeof forecastdata === 'string')
    XML2JS.parseString(forecastdata, {
        attrNameProcessors: [(name => `@${name}`)],
        explicitArray: false,
        charkey: "#text",
        mergeAttrs: true
      },
      (err, result) => {
        jsondata = result;
      }
    )
  else
    jsondata = forecastdata

  let maindata = jsondata["WxSources"];

  let currentdata = maindata["conditions"]["sfc_ob"];
  let health = maindata['health']['health'];
  let UTCtime = currentdata["ob_time"];
  let dateArr = UTCtime.split(' ')[0].split('-')
  let localtime = new Date()
  localtime.setFullYear(dateArr[0])
  localtime.setMonth(dateArr[1] - 1)
  localtime.setDate(dateArr[2])
  let updatedtime = `${dayArr[localtime.getDay()]}, ${monthArr[localtime.getMonth()]} ${localtime.getDate()}, ${localtime.getFullYear()}`;
  let localtemp = currentdata["temp"]["#text"];
  let tmpThis = this;
  let normFormat = true;

  if (typeof maindata["forecast"]["WxForecasts"] !== 'undefined') { //kwtv
    forecastdata = maindata["forecast"]["WxForecasts"]["WxForecast"];

  } else { //kotv
    forecastdata = maindata["forecast"]["forecast"]["daily_summary"];
    normFormat = false;

  }


  let iconUrl = 'http://ftpcontent.worldnow.com/griffin/gnm/testing/svg/day/';
  for (let i = 0, len = forecastdata.length; i < len; i += 1) {
    let curForecast = forecastdata[i];
    let fullDate;
    let dateStr = '';
    if (normFormat) {
      fullDate = new Date(curForecast["@Date"]);
      dateStr = `
            ${dayArr[fullDate.getUTCDay()]},
            ${monthArr[fullDate.getMonth()].substring(0, 3)} ${fullDate.getDate()},
            ${fullDate.getFullYear()}
          `;
    }
    let tmpObj = {
      key: i,
      id: normFormat ? curForecast["@WxForecastId"] : curForecast["summary_date"].replace('/', ''),
      date: normFormat ? dayArr[(new Date(curForecast["@Date"])).getUTCDay()] : dayArr[(new Date(curForecast["summary_date"])).getUTCDay()],
      condition: normFormat ? curForecast["Condition"].replace(/&amp;/g, '&') : curForecast["wx"].replace(/&amp;/g, '&'),
      conditionicon: normFormat ? `${iconUrl}${curForecast["@WxIconTypeAbbrev"]}.svg` : `${iconUrl}${formatIcon(curForecast["wx_icon_text"])}.svg`,
      low: normFormat ? curForecast["Low"] : curForecast["low"],
      high: normFormat ? curForecast["High"] : curForecast["high"],
      sunrise: normFormat ? curForecast["Sunrise"] : curForecast["sunrise"],
      sunset: normFormat ? curForecast["Sunset"] : curForecast["sunset"],
      description: normFormat ? curForecast["Description"] : '',
      windspeedmin: normFormat ? curForecast["WindSpeedMin"] : curForecast["wnd_spd"],
      windspeedmax: normFormat ? curForecast["WindSpeedMax"] : curForecast["wnd_spd"],
      winddirection: normFormat ? curForecast["WindDirection"] : curForecast["wnd_dir"],
      precipitation: normFormat ? `${curForecast["Precipitation"]}%` : `${curForecast["pop"]}%`,
      extendedTitle: `Outlook for ${dateStr}`,
      precipToggle: true,
      show: false
    };
    if (tmpObj.precipitation === '0%') {
      tmpObj.precipitation = '';
      tmpObj.precipToggle = false;
    }
    if (i < 9) {
      forecasts.push(tmpObj);
    }
  }

  function makeDateFromTimeLocal(time_local) {
    let dateTime = time_local.split(" ");
    let d = dateTime[0].split("-");
    let t = dateTime[1].split(":");
    return new Date(d[0], (d[1] - 1), d[2], t[0], t[1], t[2]);
  }

  function cleanHourForecast(a) {
    if (!a.time_local)
      return {}
    let date = makeDateFromTimeLocal(a.time_local)
    // let d = new Date(a.time_local)
    let hrs = date.getHours() + 1

    if (hrs < 12)
      a.shortTime = hrs + 'am'
    else if (hrs === 24)
      a.shortTime = '12am'
    else
      a.shortTime = hrs === 12 ? '12pm' : (hrs - 12) + 'pm'

    a.temp_F = parseInt(a.temp_F, 10)
    a.pop = parseInt(a.pop, 10)
    a.wnd_spd_mph = parseInt(a.wnd_spd_mph, 10)

    return a
  }



  return {
    updated: updatedtime,
    UTCtime: UTCtime,
    city: currentdata["location"]["#text"],
    state: currentdata["location"]["@region"],
    conditionIcon: `https://ftpcontent.worldnow.com/griffin/gnm/testing/svg/day/${currentdata["WxIconType"]["#text"]}.svg`,
    temp: currentdata["temp"]["#text"],
    moonPhase: currentdata["moon_phase"],
    cloudCover: currentdata['cld_cover'],
    uvIndex: health['uv_index']['today'],
    airQuality: health['air_quality']['today'],
    flu: health['flu'],
    conditionText: currentdata["wx"],
    feelsLike: currentdata["apparent_temp"]["#text"],
    dew: currentdata["dewp"]["#text"],
    humidity: currentdata["rh"],
    visibility: parseInt(currentdata["visibility"]["#text"] / 5280, 10),
    windSpeed: currentdata["wnd_spd"]["#text"],
    windDirection: currentdata["wnd_dir"],
    pressure: currentdata["press"]["#text"],
    forecasts,
    hourly: maindata.hourly.locations.location.forecasts.hourly.map(cleanHourForecast),
  }

}


function almanac(xml) {
  let parseString = XML2JS.parseString;
  let jsondata;
  if (typeof xml === 'string')
    parseString(xml, {
      attrNameProcessors: [(name => `@${name}`)],
      explicitArray: false,
      charkey: "#text",
      mergeAttrs: true
    }, (err, result) => {
      jsondata = result;
    })
  else
    jsondata = xml //frankly does this already
  let datasrc = jsondata['locations']['location'];
  let daydata = datasrc['day'];
  let dateValues = datasrc['day']['@date'].split('-'); //year, month, day
  let date = new Date(dateValues[0], dateValues[1] - 1, dateValues[2])

  return {
    day: datasrc['day']['@day_of_week'],
    date: date.getTime(),
    lat: parseFloat(datasrc['@request_lat']),
    lng: parseFloat(datasrc['@request_lon']),
    city: datasrc['@request_city'],
    state: datasrc['@request_state'],
    high: parseInt(daydata['temp_max']),
    low: parseInt(daydata['temp_min']),
    averageHigh: parseInt(daydata['normal_max']),
    averageLow: parseInt(daydata['normal_min']),
    recordHigh: parseInt(daydata['record_max_max']),
    recordHighYear: daydata['record_max_max_year'],
    recordLowYear: daydata['record_min_min_year'],
    recordLow: parseInt(daydata['record_min_min']),
    precip: parseFloat(daydata['precip_in']),
    precipMTD: parseFloat(daydata['precip_mtd']),
    precipYTD: parseFloat(daydata['precip_ytd']),
    snow: parseFloat(daydata['snow_day']) || 0,
    snowMTD: parseFloat(daydata['snow_mtd']) || 0,
    sunRise: daydata.sunrise_time_local,
    sunSet: daydata.sunset_time_local
  }

}

function earthquake(data) {
  data.Samples = data.Samples.map(function(s, i, a) {
    return {
      time: null,
      value: s
    }
  })
  data.Samples[0].time = data.Start
  data.Samples[data.Samples.length - 1].time = data.End

  var max = 0
  var min = 0
  data.Samples.map(function(s) {
    max = s.value > max ? s.value : max
    min = s.value < min ? s.value : min
  })
  data.max = max
  data.min = min
  return data
}

function category(data) {
  data = data || {}
  data.features = data.features || []
  data.features = data.features
    .filter(function(s) {
      return (s.type == 'story' || s.type == 'clip' || s.type == 'link')
    })
    .map(story)

  return data
}

function story(data) {
  let s = data || {}
  s.type = s.type || 'story'
  s.id = s.id || null
  s.abridged = s.abridged || {}
  s.abridged.headline = s.abridged.headline || [] //apparently they don't always have headlines either
  s.abridged.abstractimage = s.abridged.abstractimage || {};
  s.abstract = s.abstract || "";
  //s.abstract = s.abstract.replace(/<(?:.|\n)*?>/gm, '').replace(/&nbsp;/gi,' ').replace(/&rsquo;/gi,"'").replace(/&ndash;/gi,'-');
  s.abstractimage = s.abstractimage || {
    filename: ''
  }
  s.abridged.abstractimage = s.abridged.abstractimage || s.abstractimage.filename
  s.surfaceable = s.surfaceable || false
  s.link = s.link || ''
  s.flagName = s.flagName || ''
  delete s.features
  s.storyimages = s.storyimages || []
  s.bylines = s.bylines || [{}]
  s.bylines.map(function(b, i, a) {
    b.firstname = b.firstname || ''
    b.lastname = b.lastname || ''
    return b
  })

  return s
}

function noChange(r) {
  return r
}

function election(elections) {
  elections = elections || []

  elections = elections.map(function(e, i, a) {
    let s = ''
    e.race = e.race || ''
    s += e.race
    e.title = e.title || ''
    s += e.title
    e.subheader = e.subheader || ''
    s += e.subheader
    e.description = e.description || ''
    s += e.description
    e.precincts = e.precincts || 0
    e.precinctsTotal = e.precintsTotal || 0
    e.precinctsReported = e.precinctsReported || 0
    e.votes = e.votes || 0
    e.hasWinners = e.hasWinners || false
    e.candidates = e.candidates || []
    e.candidates = e.candidates.map(function(c, j, b) {
      c.firstName = c.firstName || ''
      s += c.firstName
      c.lastName = c.lastName || ''
      s += c.lastName
      c.party = c.party || ''
      if (c.party === 'D')
        s += 'democrat'
      if (c.party === 'R')
        s += 'republican'
      c.votes = c.votes || ''
      c.incumbent = c.incumbent || false
      c.winner = c.winner || false
      return c
    })
    e.searchableString = s
    return e
  })

  return elections
}

function banner(banners) {

  /*Use at your own risk:
  BannerTypeId
  2 > Live Chat
  3 > Generic Banner
  4 > Live Stream + Chat - Generic
  5 > Live Stream - Generic
  6 > Live Stream - Severe Weather
  7 > OKBlitz Live Stream
  8 > Live Stream + Chat - Severe Weather
  9 > Live Stream + Chat - Winter Weather
  10 > Live Stream + Chat - Sports
  11 > Live Stream - Sports
  12 > CBS Live Stream
  13 > Link
  14 > Link + Live Stream
  16 > Live Stream - Alert
  17 > Thunder
  20 > CBSN Live Stream*/
  banners = banners || []
  let schoolsClosed = false;
  let weatherStreaming = false;
  let schoolClosingUrl = '/closings';
  let live = false;
  let liveUrl = '/videolivestream'
  banners = banners.map((a, i) => {
    a.Title = a.Title || ''
    a.Type = a.Type || ''
    a.Link = a.Link.replace('http://www.newson6.com', '')
      .replace('http://www.news9.com', '') || ''
    a.Description = a.Description || ''
    a.Target = a.Target || ''
    a.EncoderUrls = a.EncoderUrls || [{
      Url: ''
    }]
    if (a.Link.indexOf('javascript:GNM.liveStream') !== -1) {
      a.Link = '/videolivestream?feedUrl=' + a.EncoderUrls[0].Url
    }

    if (a.BannerTypeId == 1) {
      schoolsClosed = true;
      schoolClosingUrl = a.Link;
    }
    if (a.BannerTypeId == 5) {
      live = true
    }

    if (a.Content == 'Weather - Live Streaming')
      weatherStreaming = true;

    return a
  })

  banners = banners.filter(function(a) {
    return a.BannerTypeId != 1 //remove the school closings banner
  })
  // console.log({banners, schoolClosingUrl, schoolsClosed, live,liveUrl})
  return {
    banners,
    schoolClosingUrl,
    schoolsClosed,
    weatherStreaming,
    live,
    liveUrl
  }
}



function traffic(data) {
  data = data || {}
  var dataOut = {}
  dataOut.currentTab = 'Traffic Map'
  dataOut.date = data.Date || "18/05/23 15:31:21"
  let dateTime = dataOut.date.split(' ')
  let date = dateTime[0].split('/')
  let time = dateTime[1].split(':')
  let newDate = new Date('20' + date[0], date[1] - 1, date[2], time[0], time[1], time[2])
  dataOut.timestamp = newDate.getTime()
  dataOut.incidents = data.Incidents ? data.Incidents.map(incident) : []
  dataOut.construction = data.Construction ? data.Construction.map(incident) : []
  dataOut.driveTimes = data.DriveTimes ? data.DriveTimes.map(driveTime) : []

  function makeDelay(start, end) {
    start = new Date(start)
      .getTime()
    end = new Date(end)
      .getTime()
    let delay = Math.round((end - start) / (1000 * 60))
    return delay
  }

  function incident(i) {
    var o = {}
    o.id = i.Id || 0
    o.severity = i.Severity || 0
    o.type = i.Type || 0
    o.direction = i.Direction || "None"
    o.start = i.Start || ""
    o.end = i.End || ""
    o.delay = makeDelay(o.start, o.end)
    o.roadName = i.RoadName || ""
    o.description = i.Description || ""
    o.shortDescription = i.ShortDescription || ""
    o.event = i.Event || ""
    o.collapsed = true
    return o
  }

  function driveTime(i) {
    var o = {}
    o.id = i.Id || 0
    o.severity = i.Severity || 0
    o.length = i.Length || 0
    o.minutes = i.Minutes || 0
    o.speed = i.Speed || 0
    o.direction = i.Direction || "None"
    o.start = i.Start || ""
    o.end = i.End || ""
    o.names = i.Names || ""
    o.name = i.Name || ""
    o.collapsed = true
    return o
  }

  return dataOut
}

function schoolClosing(json) {
  json = json || []

  return json.map(place)

  function place(p) {
    p.name = p.name || ''
    p.type = p.type || 1
    p.date = p.date || Date.now()
    p.status = p.status || ''
    if (!p.name || !p.status) {
      let e = new Error('*Back-end* a school closing is missing a name or status')
      Analytics.reportError(e)
    }
    return p
  }
}

function skyCam(data) {
  data = data || []
  //console.log(data)
  data = data.map(cam)

  function cam(c) {
    c.cam_name = c.cam_name || ''
    c.file_path = c.file_path || ''
    c.hasMovie = c.hasMovie === 'True'
    c.id = c.id || ''
    c.movie_path = c.movie_path || ''
    c.type = c.type || ''
    c.poster = c.file_path + (c.type == 'webcam' ? '.jpg?' : '00001.jpg?') + Date.now()
    if (!c.file_path || !c.movie_path) {
      let e = new Error('*Back-End* a Movie Path or File Path Missing from SkyCam ' + c.cam_name)
      Analytics.reportError(e)
    }
    return c
  }

  return data
}



export default {
  forecast,
  almanac,
  weatherAlert,
  skyCam: skyCam,
  banner: banner,
  earthquakeHistory: noChange,
  botSources: noChange,
  category,
  earthquake,
  story,
  seismograph: earthquake,
  election,
  traffic,
  lakeLevel: noChange,
  burnBan: noChange,
  schoolClosing
}



// WEBPACK FOOTER //
// ./app/components/custom/ssr/Cannonicalize.js